<template>
    <div>
        <div class="row data-form">
            <div class="col-12 col-md-12">
                <ValidationObserver ref="updateForm">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('excel_file')">
                                    <div class="d-flex custom-file-upload">
                                        <b-form-file v-model="defineForm.file"
                                                     :state="errors[0] ? false : (valid ? true : null)"
                                                     :placeholder="$t('select_file')"
                                                     :drop-placeholder="$t('drop_file')"
                                                     ref="fileInput"
                                                     multiple
                                        />
                                        <b-button variant="outline-secondary"
                                                  @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                        </b-button>
                                    </div>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
<!--                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <b-table class="mt-2 mb-2" borderless small bordered responsive thead-tr-class="table-success" :items="tableItems" :fields="tableFields"></b-table>
                        </div>-->
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex">
                            <b-button @click="download('student_programs_graduation-requirement_excel_import')" variant="outline-secondary" class="mr-2">{{ $t('download_excel_template') }}</b-button>
                            <b-button variant="primary"
                                      @click="sendForm"
                                      label="import"
                            />
                        </div>

                    </div>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>
<script>
// Component


// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import JobService from "@/services/JobService";
import excelImportTemplate from "@/services/ExcelImportTemplate";

export default {
    components: {

        ValidationProvider,
        ValidationObserver
    }
    ,
    data() {
        return {
            defineForm: {
                semester_id: null,
                file: null
            },
            loading: false,
            tableFields: [
                {
                    key: 'departmental_elective_ects_credit',
                    label: this.$t('sample_template_excel'),
                    tdClass: 'border text-center',
                },
                {
                    key: 'non_departmental_elective_credit',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'ge_selective_credit',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'dge_elective_number_ects_credits',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'non_departmental_elective_ects_credit',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'ge_elective_ects_credit',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'graduation_dep',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'graduation_non_dep',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'graduation_generage',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'ects_credits',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'credit',
                    label: '',
                    tdClass: 'border text-center',
                },



            ],
            tableItems: [
                {
                    departmental_elective_ects_credit: this.$t('departmental_elective_ects_credit'),
                    non_departmental_elective_credit: this.$t('non_departmental_elective_credit'),
                    ge_selective_credit: this.$t('ge_selective_credit'),
                    dge_elective_number_ects_credits: this.$t('dge_elective_number_ects_credits'),
                    non_departmental_elective_ects_credit: this.$t('non_departmental_elective_ects_credit'),
                    ge_elective_ects_credit: this.$t('ge_elective_ects_credit'),
                    graduation_dep: this.$t('graduation_dep'),
                    graduation_non_dep: this.$t('graduation_non_dep'),
                    graduation_generage: this.$t('graduation_generage'),
                    ects_credits: this.$t('ects_credits'),
                    credit: this.$t('credit'),



                },
            ]
        }
    }
    ,
    methods: {
        async sendForm() {
            const isValid = await this.$refs.updateForm.validate();
            if (isValid) {
                let formData = new FormData();
                formData.append('file', this.defineForm.file[0])
                return JobService.studentProgramsGraduationRequirement(formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.defineForm.file=null
                        this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                        this.$emit('successProcess',true)
                    })
                    .catch(e => {
                        this.showErrors(e,this.$refs.updateForm)
                    })
            }
        },
        download(code) {
            excelImportTemplate.downloadTemplate(code)
                .then(response => {
                    this._downloadFile(response, code + '.xlsx')
                })
                .catch(error => {
                    if (error.status == 422) {
                        this.$toast.error(error.data.errors.file[0]);
                    }
                    if (error.status == 406) {
                        this.$toast.error(this.$t('api.' + error.data.message));
                    }
                });
        },
    }
}
</script>
